var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-layout-body",class:{'fixed-page': !_vm.showFooter}},[_c('top-header'),_c('home-main'),(_vm.showFooter)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }